import React from 'react';
import { motion } from 'framer-motion';
import { Activity } from 'lucide-react';
import { Button } from './ui/Button';
export function Nav() {
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className="fixed top-0 left-0 right-0 z-50 bg-[#050505]/80 backdrop-blur-md border-b border-brand-panelBorder" data-id="element-116">
      <div className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between" data-id="element-117">
        <div className="flex items-center gap-2" data-id="element-118">
          <Activity className="w-6 h-6 text-brand-green" data-id="element-119" />
          <span className="font-bold text-xl tracking-tight" data-id="element-120">
            THE WEARABLE FIX
          </span>
        </div>
        <Button size="sm" onClick={() => document.getElementById('offer')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-121">
          GET PROTOCOL
        </Button>
      </div>
    </motion.nav>;
}